export default __webpack_public_path__ + "static/media/qrcode.698281d9.png";